module.exports = __webpack_public_path__ + "static/media/plant-based-lithonia-doctor.d797a518.jpg";